async function loadLibraryData() {
  const [photosResponse, albumsResponse] = await Promise.all([
    fetch("photos.json"),
    fetch("photo-albums.json").catch(() => null),
  ]);

  const photos = await photosResponse.json();
  const albumConfig = albumsResponse ? await albumsResponse.json() : null;

  return buildLibrary(photos, albumConfig);
}

function buildLibrary(photos, albumConfig) {
    const normalizedPhotos = photos.map((photo) => {
      const id = extractPhotoId(photo);
      return {
        ...photo,
        id,
        tags: Array.isArray(photo.tags) ? photo.tags : [],
        albums: Array.isArray(photo.albums) ? photo.albums : [],
      };
    });

    const configuredAlbums = Array.isArray(albumConfig?.albums)
      ? albumConfig.albums
      : [];

    const albums = configuredAlbums
      .map((album) => {
        const albumPhotos = normalizedPhotos.filter((photo) =>
          photoMatchesAlbum(photo, album)
        );

        if (!albumPhotos.length && album.id !== "all") {
          return null;
        }

        const coverPhoto =
          normalizedPhotos.find((photo) => photo.id === album.coverPhotoId) ||
          albumPhotos[0] ||
          normalizedPhotos[0];

        return {
          ...album,
          slug: album.slug || album.id,
          photos: albumPhotos,
          coverPhoto,
        };
      })
      .filter(Boolean);

    if (!albums.length) {
      albums.push({
        id: "all",
        slug: "collection",
        title: "Complete Collection",
        description: "Every photo in one continuous book.",
        photos: normalizedPhotos,
        coverPhoto: normalizedPhotos[0],
      });
    }

    const defaultAlbumId =
      albumConfig?.defaultAlbumId &&
      albums.some((album) => album.id === albumConfig.defaultAlbumId)
        ? albumConfig.defaultAlbumId
        : albums[0].id;

    return {
      photos: normalizedPhotos,
      albums,
      defaultAlbumId,
      desktopLandingTitle:
        albumConfig?.desktopLandingTitle || "Select a photo book",
      desktopLandingText:
        albumConfig?.desktopLandingText ||
        "Choose an album before opening the book.",
    };
  }

  function extractPhotoId(photo) {
    const rawValue = photo.id || photo.title || photo.full || photo.thumb || "";
    const match = String(rawValue).match(/(\d{3,4})/);
    return match ? match[1].padStart(4, "0") : rawValue;
  }

  function photoMatchesAlbum(photo, album) {
    if (album.id === "all") return true;

    if (Array.isArray(photo.albums) && photo.albums.includes(album.id)) {
      return true;
    }

    if (Array.isArray(album.photoIds) && album.photoIds.includes(photo.id)) {
      return true;
    }

    if (Array.isArray(album.idRange) && album.idRange.length === 2) {
      const [start, end] = album.idRange.map((value) =>
        String(value).padStart(4, "0")
      );
      if (photo.id >= start && photo.id <= end) {
        return true;
      }
    }

    if (Array.isArray(album.tags) && album.tags.length > 0) {
      return album.tags.some((tag) => photo.tags.includes(tag));
    }

    return false;
  }

  function getAlbumHref(album) {
    return `books/${album.slug || album.id}/`;
  }

export {
  loadLibraryData,
  buildLibrary,
  extractPhotoId,
  photoMatchesAlbum,
  getAlbumHref,
};
